import React, { useState, useEffect } from 'react';
import { getWhatsAppUrl } from '../utils/links';
import { useLanguage } from '../context/LanguageContext';
import './Nav.css';

const linkKeys = [
  { href: '#quienes-somos', key: 'about' },
  { href: '#servicios', key: 'services' },
  { href: '#mision', key: 'mission' },
  { href: '#nuestro-compromiso', key: 'commitment' },
  { href: '#lugares', key: 'destinations' },
  { href: '#faq', key: 'faq' },
  { href: '#contacto', key: 'contact' },
];

function Nav() {
  const { lang, t, toggleLang } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={`nav ${scrolled ? 'nav--scrolled' : ''} ${menuOpen ? 'nav--open' : ''}`} role="navigation" aria-label="Principal">
      <div className="nav-inner">
        <a href="#" className="nav-brand">
          <span className="nav-brand-name">ZAVE</span>
          <span className="nav-brand-tag">Transportes SpA</span>
        </a>
        <button
          type="button"
          className="nav-toggle"
          onClick={() => setMenuOpen((o) => !o)}
          aria-expanded={menuOpen}
          aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
        >
          <span /><span /><span />
        </button>
        <ul className="nav-links">
          {linkKeys.map(({ href, key }) => (
            <li key={href}>
              <a href={href} className="nav-link" onClick={closeMenu}>{t(`nav.${key}`)}</a>
            </li>
          ))}
        </ul>
        <button
          type="button"
          className="nav-lang"
          onClick={toggleLang}
          aria-label={lang === 'es' ? 'Cambiar a inglés' : 'Switch to Spanish'}
          title={lang === 'es' ? 'English' : 'Español'}
        >
          {lang === 'es' ? 'EN' : 'ES'}
        </button>
        <a
          href={getWhatsAppUrl(lang)}
          className="nav-cta"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
        >
          {t('nav.whatsapp')}
        </a>
      </div>
      <div className="nav-overlay" aria-hidden="true" onClick={closeMenu} />
    </nav>
  );
}

export default Nav;
